import { render, staticRenderFns } from "./ShareOrder.vue?vue&type=template&id=621748c2&scoped=true"
import script from "./ShareOrder.vue?vue&type=script&lang=js"
export * from "./ShareOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621748c2",
  null
  
)

export default component.exports